// src/api/fees.js
import API from "../api";

/* -------------------- FEE PLANS -------------------- */

export const listPlans = async (params = {}) => {
  // supports { branchId, includeInactive }
  const res = await API.get("/admin/fee-plans", { params });
  return res?.data ?? [];
};

export const createPlan = async (payload) => {
  const res = await API.post("/admin/fee-plans", payload);
  return res?.data;
};

export const suggestPlans = async ({
  level,
  slot = "ANY",
  deliveryMode = "ANY",
  groupType = "GROUP",
}) => {
  const params = { level, slot, deliveryMode, groupType };
  const res = await API.get("/admin/fee-plans/suggest", { params });
  return res.data;
};

// Archive (set active = false)
export const archivePlan = async (planId) => {
  return API.delete(`/admin/fee-plans/${planId}`);
};

// Activate (set active = true)
export const activatePlan = async (planId) => {
  return API.patch(`/admin/fee-plans/${planId}/activate`);
};

